import { ERROR, START, SUCCESS } from "../../../../constants/action-postfix";
import { STAFF_INFO_REQUEST } from "../staffInfoReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STAFF_INFO_REQUEST}${START}`:
            return true;
        case `${STAFF_INFO_REQUEST}${SUCCESS}`:
            return false;
        case `${STAFF_INFO_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};
